module.exports = __webpack_public_path__ + "img/lv4_1_1.e0570e5a.png";